import React from 'react'


function About() {
  return (
    <div>
      <p> This is my first React App which implements a Rest Api.
        The House Management system enables a user to view a list of houses, delete houses and add houses.

      </p>

    </div>
  )
}

export default About